import React, {useState, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import * as R from 'ramda';

import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';

import DocumentFile from '../../../constants/models/documentFile';
import $ from 'jquery';
import {uploadDocument, downloadDocument, getDocuments} from '../../../actions/user-api';
import {FileTypes, FiletypeToDisplayName} from '../../../constants/utils/fileTypes';
import {ToasterConfigurations} from '../../../constants/toasterText/configurations';

import { ModalPartager } from '../../_common/partager';
import { ModalEditFolder } from '../../_common/modalEditFolder';
import { ModalAddFile } from '../../_common/modalAddFile';
import { ModalDelete } from '../../_common/modalDelete';
import { ModalConfirmation } from './../../_common/confirmation';
import { ModalFileDescription } from '../../_common/modalEditFileDescription'
import { UploadArea } from '../../_common/upload-area';
import servicesUploading from './../../../assets/images/placeholder/ServicesUploading-ilustration.png';

export const Biblioteque = ({userId, files, isLoading}) => {
	const [selectedFileNames, setSelectedFileNames] = useState([]);
	const [currentPath, setCurrentPath] = useState("");
	const [pathLastElement, setPathLastElement] = useState([]);
	const [path, setPath] = useState([]);
	const [personalFiles, setPersonalFiles] = useState([]);
	const [selectedElementToDelete, setSelectedElementToDelete] = useState(undefined);
	const [selectedElementToEdit, setSelectedElementToEdit] = useState(undefined);
	const [modalForDefaultData, setModalForDefaultData] = useState(false);
	const [draggedFiles, setDraggedFiles] = useState([]);

	const dispatch = useDispatch();
	files = files.filter(f => f.fileType !== FileTypes.ProfilePicture && f.fileType !== FileTypes.Signature)

	function browseFolder(folderPath){
		dispatch(getDocuments({id: userId}, false, folderPath)).then((dbFiles) => {
			const persoFiles = dbFiles.map(x => new DocumentFile(x));
			setPersonalFiles([...persoFiles.filter(x => x.fileType === FileTypes.Other || x.fileType === FileTypes.Payslip || x.fileType === FileTypes.Folder  || x.fileType === FileTypes.FolderRH)]);

			let newPath = [];
			if(!R.isNil(folderPath)){
				const folderPathParts = folderPath.split('/');
				folderPathParts.map((folderPathPart, index) => {
					newPath.push({
						folderName: folderPathPart,
						fullPath: (newPath.length > 0 ? newPath[index - 1].fullPath + "/" : "") + folderPathPart,
						isRh: false
					});
				});
			}
			setPath(newPath)
		});
	}

	function browseFolderRh(folderPath, folderName){
		dispatch(getDocuments({id: userId}, false, folderPath)).then((dbFiles) => {
			const persoFiles = dbFiles.map(x => new DocumentFile(x));
			setPersonalFiles([...persoFiles.filter(x => x.fileType === FileTypes.Payslip || x.fileType === FileTypes.FolderRH)]);

			let newPath = [];
			if(!R.isNil(folderPath)){
				for(let i = 0; i < path.length; i++){
					newPath.push({...path[i], isRh: true});
					if(path[i].fullPath === folderPath){
						break;
					}
				}
				if(newPath.length === 0 || newPath[newPath.length - 1].fullPath !== folderPath){
					newPath.push({
						folderName: folderName,
						fullPath: folderPath,
						isRh: true
					})
				}
			}
			setPath(newPath)
		});
	}

	useEffect(() => {
        browseFolder();
    }, []);

	useEffect(() => {
		const lastElement = path[path.length - 1];
        setPathLastElement(lastElement);
		setCurrentPath(R.isNil(lastElement) ? undefined : lastElement.fullPath)
    }, [path]);



	return (
		<article className="view-calc py-4 mb-auto">
			<div className="container-fluid">
				<header className="block mb-1">
					<div className="flex-column flex-md-row align-items-center">
						<h4 className="h6 lh-copy text-uppercase font-weight-bolder my-auto">Vous pouvez dès à présent avancer les procédures requises en déposant les documents suivants :</h4>
						<button type="button" className="btn btn-alert-secondary btn-if p-1 rounded border-none ml-auto" data-toggle="modal" data-target="#partager" disabled={R.isEmpty(selectedFileNames)}>
							<i className="btn-icon eva eva-undo-outline eva-flip-h btn-white-info text-info rounded btn-square no-event"></i>
							<span className="btn-text px-3">Partager</span>
						</button>
						<ModalPartager fileNames={selectedFileNames} userId={userId} userRepresentativeId={userId} isLoading={isLoading} />
					</div>
				</header>
			</div>
			{/* <div className="auto-view pt-3 py-lg-0"> */}
				<div className="container-fluid">

					<div className="flex-column h-100">
						<section className="flex-column mb-4">
							<h1 className="fs-3 font-weight-bolder text-uppercase ls-2 o-60">Documents utiles</h1>
							<form className="grid grid-sm-narrow grid-xl-2 grid-hd-4 pb-sm">
								{/* <section className="flex-row flex-fill gap-2">
									<UploadArea documentName={FiletypeToDisplayName(FileTypes.UserIdCard)} uploadedFile={files.find(x => x.fileType === FileTypes.UserIdCard)}
										uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.UserIdCard, document, description))}
										downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
										deleteFile={(document) => dispatch(deleteDocument(userId, document.fileName))}
									/>
									<UploadArea documentName={FiletypeToDisplayName(FileTypes.UserFamilyRecordBook)} uploadedFile={files.find(x => x.fileType === FileTypes.UserFamilyRecordBook)}
										uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.UserFamilyRecordBook, document, description))}
										downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
										deleteFile={(document) => dispatch(deleteDocument(userId, document.fileName))}
									/>
								</section>
								<section className="flex-row flex-fill gap-2">
									<UploadArea documentName={FiletypeToDisplayName(FileTypes.UserDonation)} uploadedFile={files.find(x => x.fileType === FileTypes.UserDonation)}
										uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.UserDonation, document, description))}
										downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
										deleteFile={(document) => dispatch(deleteDocument(userId, document.fileName))}
									/>
									<UploadArea documentName={"Télécharger"} labelName={"Avancer les procédures requises en déposant les documents..."} modalTelechargerArea={false} toggleTelechargerArea={true} telechargerArea={true} documentType={FileTypes.Other}
										uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.Other, document, description))}
										downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
										deleteFile={(document) => dispatch(deleteDocument(userId, document.fileName))}
									/>
								</section> */}
								<UploadArea documentName={FiletypeToDisplayName(FileTypes.UserIdCard, false)} 
										documentType={FiletypeToDisplayName(FileTypes.UserIdCard, false)}
										uploadedFile={files.find(x => x.fileType === FileTypes.UserIdCard)}
										uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.UserIdCard, document, description))}
										downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
										deleteFile={(document) => {
											setSelectedElementToDelete(document);
											$('#deleteDoc').modal("show");
										}}
										editDescription={(document) => {
											setSelectedElementToEdit(document);
											$('#ModalFileDescription').modal("show");
										}}
										selectable={true}
										selectedFiles={selectedFileNames}
										setSelectFiles={setSelectedFileNames}
									/>
								<UploadArea documentName={FiletypeToDisplayName(FileTypes.UserFamilyRecordBook, false)} uploadedFile={files.find(x => x.fileType === FileTypes.UserFamilyRecordBook)}
										documentType={FiletypeToDisplayName(FileTypes.UserFamilyRecordBook, false)}
										uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.UserFamilyRecordBook, document, description))}
										downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
										deleteFile={(document) => {
											setSelectedElementToDelete(document);
											$('#deleteDoc').modal("show");
										}}
										editDescription={(document) => {
											setSelectedElementToEdit(document);
											$('#ModalFileDescription').modal("show");
										}}
										selectable={true}
										selectedFiles={selectedFileNames}
										setSelectFiles={setSelectedFileNames}
									/>
								<UploadArea documentName={FiletypeToDisplayName(FileTypes.UserDonation, false)} uploadedFile={files.find(x => x.fileType === FileTypes.UserDonation)}
										documentType={FiletypeToDisplayName(FileTypes.UserDonation, false)}
										uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.UserDonation, document, description))}
										downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
										deleteFile={(document) => {
											setSelectedElementToDelete(document);
											$('#deleteDoc').modal("show");
										}}
										editDescription={(document) => {
											setSelectedElementToEdit(document);
											$('#ModalFileDescription').modal("show");
										}}
										selectable={true}
										selectedFiles={selectedFileNames}
										setSelectFiles={setSelectedFileNames}
									/>
								{
									files.filter(file =>
										file.fileType !== FileTypes.UserIdCard &&
										file.fileType !== FileTypes.UserFamilyRecordBook &&
										file.fileType !== FileTypes.UserDonation &&
										file.fileType !== FileTypes.Other &&
										file.fileType !== FileTypes.Folder &&
										file.fileType !== FileTypes.FolderRH).map((file, index) =>
										{
											return <UploadArea documentName={FiletypeToDisplayName(file.fileType)} uploadedFile={file}
												documentType={FiletypeToDisplayName(file.fileType, false)}
												uploadFile={(document, description) => dispatch(uploadDocument(userId, file.fileType, document, description))}
												downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
												deleteFile={(document) => {
													setSelectedElementToDelete(document);
													$('#deleteDoc').modal("show");
												}}
												editDescription={(document) => {
													setSelectedElementToEdit(document);
													$('#ModalFileDescription').modal("show");
												}}
												key={file.fileName + index}
												selectable={true}
												selectedFiles={selectedFileNames}
												setSelectFiles={setSelectedFileNames}
											/>
										})
								}
								<div className="card py-3 border-0 shadow-xs--hover rounded upload-card btn-alert-secondary" data-toggle="modal" data-target="#fichier" onClick={(e) => setModalForDefaultData(true)}>
									<div className="card-body flex-row gap-3 my-auto py-0" role="button">
										<div className="rounded-max d-inherit h-6 w-6 rounded-max text-center my-auto flex-shrink-0 bg-white text-secondary">
											<i className="eva eva-cloud-upload-outline h1 lh-1 m-auto o-60"></i>
										</div>
										<div className="flex-column flex-fill my-auto">
											<h3 className="fs-root mb-0 lh-copy my-auto">Télécharger</h3>
											<p className="small o-60 mb-0 lh-copy my-auto container-up">Charger un document utile</p>
										</div>
									</div>
								</div>
							</form>
						</section>
						<section className="flex-column">
                    		<div className="flex-row gap-3 mb-3">
								<div className="flex-column gap-1">
									<h2 className="fs-3 font-weight-bolder text-uppercase ls-2 o-60 my-auto">
									Dossiers personnalisés
									</h2>
									<div className="flex-row align-items-center gap-2">
										<h2 className="fs-1 font-weight-bolder text-uppercase ls-2 my-auto o-40 o-100--hover" role="button" onClick={(e) => {browseFolder() }}>
											<i className="eva eva-arrow-right fs-root lh-1 align-middle mr-1"></i>
											<span className="align-middle">Dossier</span>
										</h2>
										{
											path.map((part) =>{
												return (
													<>
														<span className="my-auto o-20">/</span>
														<h2 className={"fs-1 font-weight-bolder text-uppercase ls-2 my-auto" + (R.isNil(pathLastElement) || part.fullPath === pathLastElement.fullPath ? " o-80 text-aux"  : " o-40 o-100--hover")} role="button" onClick={(e) => {
															if(part.isRh){
																browseFolderRh(part.fullPath, part.folderName); 
															}else{
																browseFolder(part.fullPath);
															}}}>
															{/* <i className="eva eva-folder-outline fs-root lh-1 align-middle mr-1"></i> */}
															<span className="align-middle">{part.folderName}</span>
														</h2>
													</>
												)
											})
										}
									</div>


								</div>
								<div className="flex-row gap-2 my-auto ml-auto">
									<div className="btn-group">
										<button type="button" className="btn btn-alert-aux btn-if p-1 rounded border-none" data-toggle="dropdown" aria-expanded="false" disabled={!R.isNil(pathLastElement) && pathLastElement.isRh}>
											<i className="btn-icon eva eva-plus-outline fs-root lh-1 btn-white-warning text-aux rounded btn-square no-event"></i>
											<span className="btn-text px-3">
												<span className="align-middle mr-1">Nouveau</span>
												<i className="eva eva-arrow-down fs-root lh-1 align-middle"></i>
											</span>
										</button>
										<div className="dropdown-menu dropdown-menu-right shadow-lg gap-1 border-0 p-2">
											<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" data-toggle="modal" data-target="#ModalEditFolder">
												<i className="eva eva-folder-outline mr-2"></i>
												<span className="ls-n3">Dossier</span>
											</button>
											<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" data-toggle="modal" data-target="#fichier" onClick={(e) => setModalForDefaultData(false)}>
												<i className="eva eva-file-outline mr-2"></i>
												<span className="ls-n3">Fichier</span>
											</button>
										</div>
									</div>
								</div>
							</div>



					<Dropzone
                        onDrop={acceptedFiles => {
                            if(!R.isEmpty(acceptedFiles)){
                                setDraggedFiles(acceptedFiles.map(f => {
                                    f.description = null;
                                    f.fileType = FileTypes.Other
                                    return f;
                                }));
                                $("#fichier").modal("show");
                            }
                        }}
                        onDropRejected={(filesErrors) => {
                            filesErrors.map(fileErrors => fileErrors.errors.map(error => {
                                if(error.code === 'file-invalid-type'){
                                    toast.error(`Le fichier '${fileErrors.file.name}' n'est pas un fichier PDF.`, ToasterConfigurations)
                                }
                            }))
                        }}

                        noClick={true}
                        accept={"application/pdf"}>
                        {({ isDragActive, getRootProps, getInputProps }) => (
                        (personalFiles.length === 0) ?
                            <article {...getRootProps({className: "flex-column px-3 py-5 my-3 h-100" + (isDragActive ? " dropzone-focused" : "")})}>
                                <input {...getInputProps()} />
                                <div className="container container-base text-center m-auto">
                                    <h5 className="sr-only visually-hidden">Biblioteque - Empty</h5>
                                    <img className="img-fluid mx-auto container-md-narrow mb-3 img-blend" src={servicesUploading} alt="features overview" />
                                    <h1 className="h1 font-weight-black ls-n3 lh-1 mb-1">Déposez vos fichiers ici.</h1>
                                    <p className="fs-default mb-4 o-60">ou utilisez le bouton "télécharger"</p>
                                    <button type="button" className="btn btn-alert-info btn-if p-1 rounded border-none ml-auto" data-toggle="modal" data-target="#fichier" disabled="" onClick={(e) => setModalForDefaultData(false)}>
                                        <i className="btn-icon eva eva-cloud-upload-outline btn-white-info text-info rounded btn-square no-event fs-root"></i>
                                        <span className="btn-text px-3">Télécharger</span>
                                    </button>
                                </div>
                            </article>


                        :
                            <article {...getRootProps({className: "flex-column mx-nsm" + (isDragActive ? " dropzone-focused" : "")})}>
                                <input {...getInputProps()} />
                                <section className="grid grid-sm-narrow grid-xl-2 grid-hd-4 p-sm">
                                    {personalFiles.filter(x =>
                                        x.fileType === FileTypes.Other ||
                                        x.fileType === FileTypes.Folder ||
										x.fileType === FileTypes.FolderRH ||
										x.fileType === FileTypes.Payslip).map((file) => {
                                            if(file.fileType === FileTypes.Folder || file.fileType === FileTypes.FolderRH){
                                                let folderFullName = (R.isNil(pathLastElement) ? "" :  pathLastElement.fullPath + "/") + file.fileName;
												if(file.fileType === FileTypes.FolderRH){
													folderFullName = "RH:" + file.description
												}
                                                return (<div className="card border-0 rounded upload-card bg-mix bg-light--hover" key={file.fileName} >
                                                <div className="card-body flex-column gap-2 my-auto">
                                                        <div className="flex-row flex-grow-1 gap-3 justify-content-between my-auto">
                                                            <h3 className="fs-1 o-60 my-auto text-uppercase font-weight-bold ls-2">Dossier {file.fileType === FileTypes.FolderRH ? 'RH' : ''}</h3>
															<div className="custom-control custom-checkbox checkbox-cc ml-auto mr-n1">
                                                                <input type="checkbox" className="custom-control-input" id={file.fileName} onChange={() => {
                                                                    if (selectedFileNames.indexOf(folderFullName + "/*") === -1) {
                                                                        setSelectedFileNames([...selectedFileNames, folderFullName + "/*"]);
                                                                    } else {
                                                                        setSelectedFileNames(selectedFileNames.filter(s => s !== folderFullName + "/*"));
                                                                    }
                                                                }}/>
                                                                <label className="custom-control-label text-none border-gray fs-0 ml-1" htmlFor={file.fileName}>Select</label>
                                                            </div>
                                                        </div>
                                                        <div className="flex-row flex-grow-1 gap-3 my-auto" role="button">
                                                            <div className="rounded-max d-inherit h-6 w-6 rounded-max text-center my-auto flex-shrink-0 bg-dim">
                                                                <i className="eva eva-folder-outline h1 lh-1 m-auto o-60"></i>
                                                            </div>
                                                            <div className="flex-column flex-fill my-auto" onClick={(e) => {
                                                                e.preventDefault();
																if(file.fileType === FileTypes.FolderRH){
																	browseFolderRh(folderFullName, file.fileName)
																}else{
																	browseFolder(folderFullName)
																}
                                                                
                                                            }}>
                                                                <h3 className="fs-root mb-0 lh-copy my-auto">{file.fileName}</h3>
                                                                {/* <p className="small o-60 mb-0 lh-copy my-auto">10 documents</p> */}
                                                            </div>
															<div className="btn-group">
																<button type="button" className="btn btn-square btn-mix text-inherit border-0 rounded-sm my-auto flex-shrink-0" data-toggle="dropdown" aria-expanded="false">
																	<i className="eva eva-more-vertical-outline fs-root lh-1 align-middle"></i>
																</button>
																<div className="dropdown-menu dropdown-menu-right shadow-lg gap-1 border-0 p-2">
																	{
																		file.fileType === FileTypes.FolderRH ? 
																			''
																		:
																			<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" data-toggle="modal" data-target="#deleteDoc" onClick={(e) => {
																				setSelectedElementToDelete(file)
																			}}>
																				<span className="ls-n3">Supprimer dossier</span>
																			</button>
																	}
																	<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={(e) => {
																		e.preventDefault();
																		if(file.fileType === FileTypes.FolderRH){
																			browseFolderRh(folderFullName, file.fileName)
																		}else{
																			browseFolder((R.isNil(pathLastElement) ? "" :  pathLastElement.fullPath + "/") + file.fileName)
																		}
																		
																	}}>
																		<span className="ls-n3">Voir dossier</span>
																	</button>
																</div>
															</div>
                                                        </div>
                                                    </div>
                                                </div>)

                                            }else{
                                                file.path = currentPath;
                                                return <UploadArea key={file.fileName} documentName={file.fileName} documentType={file.fileType} uploadedFile={file}
                                                uploadFile={(document, description) => dispatch(uploadDocument(userId, file.fileType, document, description))}
                                                downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName, file.fileType === FileTypes.Payslip ? "RH:" + document.description : currentPath))}
                                                deleteFile={(document) => {
                                                    setSelectedElementToDelete(document);
                                                    $('#deleteDoc').modal("show");
                                                }}
												editDescription={(document) => {
													setSelectedElementToEdit(document);
													$('#ModalFileDescription').modal("show");
												}}
												selectable={true}
                                                selectedFiles={selectedFileNames}
                                                setSelectFiles={setSelectedFileNames}
                                            />
                                            }

                                        })
                                    }
                                </section>
                            </article>
                        )}
                    </Dropzone>




							{/* {(personalFiles.length === 0) ?
								<section className="flex-column p-3 my-5 h-100">
									<div className="container container-base text-center m-auto">
										<h5 className="sr-only visually-hidden">Biblioteque - Empty</h5>
										<img className="img-fluid mx-auto container-md-narrow mb-3 img-blend" src={servicesUploading} alt="features overview" />
										<div className="h1 font-weight-black ls-n3 lh-1 mb-1">Déposez vos fichiers ici.</div>
										<p className="fs-default mb-4 o-60">ou utilisez le bouton "télécharger"</p>
										<button type="button" className="btn btn-alert-secondary btn-if p-1 rounded border-none ml-auto" data-toggle="modal" data-target="#fichier" disabled="" onClick={(e) => setModalForDefaultData(false)}>
											<i className="btn-icon eva eva-cloud-upload-outline btn-white-secondary text-secondary rounded btn-square no-event fs-root"></i>
											<span className="btn-text px-3">Télécharger</span>
										</button>
									</div>
								</section>
								:
								<section className="grid grid-sm-narrow grid-xl-4 py-sm">
									{personalFiles.filter(x =>
										x.fileType === FileTypes.Other ||
										x.fileType === FileTypes.Folder).map((file) => {
											if(file.fileType === FileTypes.Folder){
												return (<div className="card border-0 rounded upload-card bg-mix bg-light--hover" key={file.fileName}>
												<div className="card-body flex-column gap-2 my-auto">
														<div className="flex-row flex-grow-1 gap-3 justify-content-between my-auto">
															<h3 className="fs-1 o-60 my-auto text-uppercase font-weight-bold ls-2">Dossier</h3>
														</div>
														<div className="flex-row flex-grow-1 gap-3 my-auto" role="button">
															<div className="rounded-max d-inherit h-6 w-6 rounded-max text-center my-auto flex-shrink-0 bg-dim">
																<i className="eva eva-folder-outline h1 lh-1 m-auto o-60"></i>
															</div>
															<div className="flex-column flex-fill my-auto" onClick={(e) => {
																e.preventDefault();
																browseFolder((R.isNil(pathLastElement) ? "" :  pathLastElement.fullPath + "/") + file.fileName)
															}}>
																<h3 className="fs-root mb-0 lh-copy my-auto">{file.fileName}</h3>
															</div>
															<div className="btn-group">
																<button type="button" className="btn btn-square btn-mix text-inherit border-0 rounded-sm my-auto flex-shrink-0" data-toggle="dropdown" aria-expanded="false">
																	<i className="eva eva-more-vertical-outline fs-root lh-1 align-middle"></i>
																</button>
																<div className="dropdown-menu dropdown-menu-right shadow-lg gap-1 border-0 p-2">
																	<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" data-toggle="modal" data-target="#deleteDoc" onClick={(e) => {
																		setSelectedElementToDelete(file)
																	}}>
																		<span className="ls-n3">Supprimer dossier</span>
																	</button>
																	<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={(e) => {
																		e.preventDefault();
																		browseFolder((R.isNil(pathLastElement) ? "" :  pathLastElement.fullPath + "/") + file.fileName)
																	}}>
																		<span className="ls-n3">Voir dossier</span>
																	</button>
																</div>
															</div>
														</div>
													</div>
												</div>)

											}else{
												return <UploadArea key={file.fileName} documentName={file.fileName} documentType={file.fileType} uploadedFile={file}
												uploadFile={(document, description) => dispatch(uploadDocument(userId, file.fileType, document, description))}
												downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName, currentPath))}
												deleteFile={(document) => {
													setSelectedElementToDelete(document);
													$('#deleteDoc').modal("show");
												}}
											/>
											}

										})
									}
								</section>
							} */}
						</section>
					</div>
				</div>
			{/* </div> */}
			<ModalConfirmation />

			<ModalAddFile userId={userId} currentPath={currentPath} onFileAdded={() => browseFolder(currentPath)}  isDefaultFiles={modalForDefaultData} injectedFiles={draggedFiles} isFacilita={false} />
			<ModalEditFolder userId={userId} currentPath={currentPath} onFolderEdited={() => browseFolder(currentPath)}  />
			<ModalDelete userId={userId} elementToDelete={selectedElementToDelete} currentPath={currentPath} onFileDelete={() => browseFolder(currentPath)} />
			<ModalFileDescription userId={userId} currentPath={currentPath} onDocumentEdited={() => browseFolder(currentPath)} document={selectedElementToEdit} />
		</article>
	)
}